const commonReducer = (state = {}, action) => {
    switch (action.type) {
      case "SHOW_LOADER":
        return Object.assign({}, state, {
          loading: action.data,
        });
        case "SIDE_MENU":
        return Object.assign({}, state, {
          sideMenu: action.data,
        });
        case "EDIT_CANCEL":
          return Object.assign({}, state, {
            editCancel: action.data,
          });
      default:
        return state;
    }
  };
  
  export default commonReducer;